import { render, staticRenderFns } from "./gzhuizongb.vue?vue&type=template&id=287db730&scoped=true&"
import script from "./gzhuizongb.vue?vue&type=script&lang=js&"
export * from "./gzhuizongb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287db730",
  null
  
)

export default component.exports